export const BookWalkerChip = 'book-walker-chip';
